import { render, staticRenderFns } from "./LiberarAsientoView.vue?vue&type=template&id=3a098f86"
import script from "./LiberarAsientoView.vue?vue&type=script&setup=true&lang=js"
export * from "./LiberarAsientoView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports